import { BaseLookupModel, PaginationFilterRequest } from '@/models/core.model';

export interface City {
    id: number;
    name: string;
    country?: BaseLookupModel;
    code: string;
    imageUrl: string;
    status: CityStatusEnum;
    lat: number;
    lon: number;
    jsonGeometry?: string;
    ianaTimeZoneId: string;
    countryId: number;
    supportedFeatures?: CitySupportedFeatureEnum[];
    /** The language multi-language content (e.g. Energy Hubs) is shown in here; empty = English. */
    languageCode?: string;
}

export interface UpsertCity {
    id?: number;
    name?: string;
    countryId?: number;
    code?: string;
    imageUrl?: string;
    status: CityStatusEnum;
    lat?: number;
    lon?: number;
    ianaTimeZoneId?: string;
    supportedFeatures?: CitySupportedFeatureEnum[];
    languageCode?: string;
}

export class CityPaginationFilterRequest extends PaginationFilterRequest{  
    countryId? : number;
}

export enum CityStatusEnum {
    Disable,
    Enable,
}

export const CityStatusList = [
    { value: 0, label: "Disable" },
    { value: 1, label: "Enable" },
];

export enum CitySupportedFeatureEnum {
    Explorer = 0,
    EnergyHub = 1,
}

export const CitySupportedFeatureList = [
    { value: CitySupportedFeatureEnum.Explorer, label: "Explorer" },
    { value: CitySupportedFeatureEnum.EnergyHub, label: "Energy Hub" },
];


export interface CityGeometry {
    CityId: number;
    jsonGeometry: string;
}

export interface UpsertCityGeometry {
    cityId?: number;
    jsonGeometry?: string;
}

// H3 cells (hex strings, e.g. "8a411cb243fffff") that make up a city
export interface CityCells {
    cityId: number;
    cells: string[];
}

export interface SaveCityCellsResult {
    saved: boolean;
    cells: string[];
    conflicts: { cell: string; otherCityId: number; otherCityCell: string }[];
    invalidCells: string[];
}

export interface FillCityCellsFromGeoJson {
    jsonGeometry: string;
    resolution: number;
    save: boolean;
    skipCellsOfOtherCities: boolean;
}

export interface CityCellsInViewFilter {
    minLat: number;
    minLng: number;
    maxLat: number;
    maxLng: number;
    excludeCityId?: number;
}

export interface CityCellInView {
    cell: string;
    cityId: number;
}
